// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, chatHistoryListingProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetChatHistoryProfessionalApi = createAsyncThunk(
  "hitGetChatHistoryProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + chatHistoryListingProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetChatHistoryProfessionalSlice = createSlice({
  name: "getChatHistoryProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetChatHistoryData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetChatHistoryProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetChatHistoryProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetChatHistoryProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetChatHistoryData } = GetChatHistoryProfessionalSlice.actions;
export default GetChatHistoryProfessionalSlice.reducer;
